export default "__VITE_ASSET__B_68233P__"